module.exports = __webpack_public_path__ + "img/Frame-18.93c6775f.svg";